import { useQuery } from "@tanstack/react-query";
import { fetchSafesByUserAddress } from "../services/profile";
import { queryKeys } from "../lib/queryKeys";
import { QUERY_TIERS } from "../lib/queryConfig";

// Main safes query hook
export const useSafes = (address: string, hasSafes: boolean) => {
  const query = useQuery({
    queryKey: queryKeys.safes.list(address),
    queryFn: () => fetchSafesByUserAddress({ address }),
    enabled: !!address && hasSafes,
    ...QUERY_TIERS.profile,
  });

  // Debug logging
  // console.log('useSafes Debug:', {
  //   address,
  //   isLoading: query.isLoading,
  //   isError: query.isError,
  //   data: query.data ? `${query.data.length} safes found` : 'No safes data',
  //   error: query.error,
  //   isFetching: query.isFetching,
  //   isSuccess: query.isSuccess,
  //   isRefetching: query.isRefetching,
  //   isLoadingError: query.isLoadingError,
  //   isStale: query.isStale,
  //   isFetched: query.isFetched,
  //   isFetchedAfterMount: query.isFetchedAfterMount,
  // });

  return query;
};
